import { render, staticRenderFns } from "./pluginsTable.vue?vue&type=template&id=3429f1f2&scoped=true"
import script from "./pluginsTable.vue?vue&type=script&lang=js"
export * from "./pluginsTable.vue?vue&type=script&lang=js"
import style0 from "./pluginsTable.vue?vue&type=style&index=0&id=3429f1f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429f1f2",
  null
  
)

export default component.exports